import { Component, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import templateContent from "./main-nav.html";
import "./style.css";

import activityListView from "../../views/activity/activityListView";
import loginView from "../../views/login/loginView";
import profileView from "../../views/profile/profileView";
import projectListView from "../../views/project/projectListView";
import themeSwitchComponent from "../theme-switch/themeSwitchComponent";

class MainNavComponent extends Component {
	constructor () {
		super("mainNavComponent");
		this.addTemplate("", templateContent);
	}
	
	homeBtn_clickHandler (event) {
		event.preventDefault();
		event.stopPropagation();

		Shark.openPage(projectListView, {urlSearchParams: null });
	}

	init () {
		this.addComponents([themeSwitchComponent]);
	}
	
	navBackBtn_clickHandler (event) {
		event.preventDefault();
		event.stopPropagation();

		const urlParams = new URLSearchParams(document.location.search);

		if (urlParams.has("actguid") && urlParams.has("prjguid") &&  Shark.activePage.id === "taskListView") {
			// Dave.ToDo: Shark non elimina gli URLParams già presenti se ne imposto di nuovo
			Shark.openPage(activityListView, { urlSearchParams: { actguid: "", prjguid: urlParams.get("prjguid")} });
		}
		else {
			history.back();
		}
	}

	navLogOutBtn_clickHandler (event) {
		event.preventDefault();
		event.stopPropagation();
		
		Shark.set({
			activityList: [],
			// activityViewFilters: null,
			projectList: [],
			// projectViewFilters: null,
			taskList: [],
			// taskViewFilters: null,
		});

		NousCore.api.abandonSession();
		Shark.openPage(loginView, {urlSearchParams: null });
	}
	
	navProfileBtn_clickHandler (event) {
		event.preventDefault();
		event.stopPropagation();

		Shark.openPage(profileView, {urlSearchParams: null });
	}
}

const mainNavComponent = new MainNavComponent();

Shark.registerComponent(mainNavComponent);

export default mainNavComponent;
